__webpack_require__.p = "/wp-content/plugins/devis/widget/build/";